/**
 * Repository of routes for the entry-form-api module
 *
 * Keyed by type of form (entrant / manager) and then by the route name.
 * All of the routes should be defined here.
 */
const routesRepo = {
  entrant: {
    preview: entry => `/entry/entrant/${entry}/preview`,
    start: () => `/entry-form/entrant/start`,
    save: entry => `/entry-form/entrant/entry/${entry}/autosave`,
    submit: entry =>
      entry
        ? `/entry-form/entrant/entry/${entry}/submit`
        : `/entry-form/entrant/entry/submit`,
    edit: entry => `/entry-form/entrant/${entry}/edit`,
    index: () => `/entry/entrant`,
    complete: payload => `/entry/entrant/complete/${payload.entry}`,
    pay: entry => `/entry-form/entrant/${entry}/pay`,
    cart: () => '/cart',
    categories: (seasonId, chapterId, trashed, active) =>
      `/entry-form/entrant/categories/${seasonId}/${chapterId}?trashed=${trashed}&active=${active}`
  },
  manager: {
    preview: entry => `/entry/manager/${entry}/preview`,
    start: () => `/entry-form/manager/start`,
    save: entry => `/entry-form/manager/entry/${entry}/autosave`,
    submit: entry =>
      entry
        ? `/entry-form/manager/entry/${entry}/submit`
        : `/entry-form/manager/entry/submit`,
    edit: entry => `/entry-form/manager/${entry}/edit`,
    index: () => `/entry/manager`,
    complete: payload => `/entry/manager/complete/${payload.entry}`,
    categories: (seasonId, chapterId, trashed, active) =>
      `/entry-form/manager/categories/${seasonId}/${chapterId}?trashed=${trashed}&active=${active}`
  }
};

/**
 * routes - routes object selected according to routeSet
 * saveUrl - an URL for saving a form
 * submitUrl - an URL for submitting a form
 * previewUrl - an URL for the entry preview
 * editUrl - an URL for entry edit with tab slug
 * isFormDirty - returns true if there's unsaved data
 */
export default {
  routes: state => routesRepo[state.routeSet],

  startUrl: (state, getters) => getters.routes.start(),

  payUrl: (state, getters, rootState, rootGetters) => {
    const entrySlug = rootGetters['entryForm/entrySlug'];
    return entrySlug ? getters.routes.pay(entrySlug) : getters.routes.start();
  },

  saveUrl: (state, getters, rootState, rootGetters) => {
    const entrySlug = rootGetters['entryForm/entrySlug'];
    return entrySlug ? getters.routes.save(entrySlug) : getters.routes.start();
  },

  submitUrl: (state, getters, rootState, rootGetters) => {
    const entrySlug = rootGetters['entryForm/entrySlug'];
    return getters.routes.submit(entrySlug);
  },

  previewUrl: (state, getters, rootState, rootGetters) => {
    const entrySlug = rootGetters['entryForm/entrySlug'];
    return entrySlug
      ? getters.routes.preview(entrySlug)
      : getters.routes.index();
  },

  editUrl: (state, getters, rootState, rootGetters) => {
    const entrySlug = rootGetters['entryForm/entrySlug'];
    return entrySlug ? getters.routes.edit(entrySlug) : getters.routes.start();
  },

  isFormDirty: (state, getters, rootState, rootGetters) =>
    rootGetters['entryForm/isDirty'],

  hasEntry: (state, getters, rootState, rootGetters) =>
    rootGetters['entryForm/entrySlug'] !== null,

  isLoaded: (state, getters, rootState, rootGetters) =>
    rootGetters['entryForm/isLoaded'],

  isSaveable: (state, getters, rootState, rootGetters) =>
    rootGetters['entryForm/isSaveable'],

  attachmentsLoaded: (state, getters, rootState) =>
    rootState['entryForm'].attachmentsLoaded,

  contributorsLoaded: (state, getters, rootState) =>
    rootState['entryForm'].contributorsLoaded,

  configurationMode: (state, getters, rootState) =>
    rootState['entryFormConfiguration'].configurationMode
};
